/* eslint-disable react-hooks/exhaustive-deps */
import { Box, CardMedia, Skeleton } from '@mui/material';
import { useEffect, useState } from 'react';
import { fileTypeChecks } from 'utils/file-icon';
import { useDispatch } from 'react-redux';

import { useFilePreviewDialog } from 'contexts/FilePreviewDialogContext';
import { getFilePreview } from 'store/slices/files';

export const DialogImagePreview = ({ file = {} }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const { setFilePreview } = useFilePreviewDialog();

  useEffect(() => {
    let isMounted = true;

    if (file?.preview) {
      if (isMounted) setIsLoading(false);
      return;
    }
    if (file.oid && !file?.preview && fileTypeChecks.isFileImage(file)) {
      if (isMounted) setIsLoading(true);
      dispatch(getFilePreview({ id: file.oid }))
        .unwrap()
        .then(async (data) => {
          setFilePreview(file.id, data);
          setIsLoading(false);
        })
        .catch(() => {
          if (isMounted) setIsLoading(false);
        });
    }

    return () => {
      isMounted = false;
    };
  }, [file?.oid]);

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '70%',
        maxHeight: '70%',
        margin: 'auto',
      }}
    >
      {isLoading && (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 10,
            background: 'linear-gradient(75deg, rgba(127,127,127,0.81) 0%, rgba(51,51,51,0.86) 100%)',
            borderRadius: '12px',
          }}
        />
      )}

      {file?.preview && !isLoading && (
        <Box
          sx={{
            display: 'inline-flex',
            backgroundColor: 'transparent',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CardMedia
            component="img"
            image={file.preview}
            alt={file.name}
            sx={{
              width: 'auto',
              height: '70vh',
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Box>
      )}
    </Box>
  );
};
